module.exports = __webpack_public_path__ + "static/media/CrossButtonForCallbacks.99682500.svg";